import { gql } from "../../../__generated__/gql";


export const GET_NOTIFICATION_HISTORY = gql(`query notificationHistories {
  notificationHistories(orderBy: {
    date: desc
  }, take: 20) {
    id
    date
    title
    message
    exportNumber
  }
}`)

export const DELETE_NOTIFICATION = gql(`mutation deleteNotification($notificationId: Int!) {
  deleteNotification(notificationId: $notificationId)
}`)